<template>
	<div class="dashboard w-100">
		<div v-if="!IsAuthenticated || !LinksLoadedAuth">
			<p>Willkommen bei der Athletix App. Über diese App können Sie verschiedene Seltec Dienste komfortabel auf Ihrem Smartphone nutzen.</p>
			<p>
				Loggen Sie sich bitte mit Ihren LA.net oder Service-Portal Zugangsdaten ein, um die Dienste zu nutzen.
				Sollten Sie noch keine Zugangsdaten haben, registrieren Sie sich bitte neu.
			</p>

			<!-- <page-sub-title :title="'loginTitle'" :info="''"></page-sub-title> -->
			<v-row>
				<v-col v-for="(link, i) in links" :key="i" cols="6" sm="3" md="3" lg="2" xl="1">
					<dashboard-link :to="{name: link.link}" :title="link.text" :icon="link.icon"></dashboard-link>
				</v-col>
			</v-row>
		</div>
		<div v-else>
			<v-row>
				<v-col v-for="(link, i) in linksAuth" :key="i+'-auth'" cols="6" sm="3" md="3" lg="2" xl="1">
			<dashboard-link :to="{name: link.link}" :title="link.text" :icon="link.icon"></dashboard-link>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import namespace from '../store/namespace';

// import PageSubTitle from '../general/PageSubTitle.vue';
import DashboardLink from '../navigation/DashboardLink.vue';


export default {
	name: 'Dashboard',
	components: {
		// PageSubTitle,
		DashboardLink,
	},
	computed: {
		...mapGetters(namespace.AUTH, ['IsAuthenticated']),
		...mapGetters(['LinksLoadedAuth']),
	},
	data() {
		return {
			links: [{
				text: this.$t('text.loginHeader'),
				link: 'login',
				icon: 'mdi-login',
			}, {
				text: this.$t('text.registerButton'),
				link: 'register',
				icon: 'mdi-account-plus-outline',
			},
			{
				text: this.$t('text.eventRegistration'),
				link: 'eventRegistrationCompetitions',
				icon: 'mdi-format-list-checks',
			}],
			linksAuth: [{
				text: this.$t('text.regMans'),
				link: 'competitions',
				icon: 'mdi-qrcode-scan',
			},
			{
				text: this.$t('text.eventRegistration'),
				link: 'eventRegistrationCompetitions',
				icon: 'mdi-format-list-checks',
			},
			],
		};
	},
	watch: {
		IsAuthenticated() {
			if (this.IsAuthenticated && this.$route.query && this.$route.query.redirect) {
				this.$router.push(this.$route.query.redirect);
			}
		},
	},
};
</script>

<style lang="scss" scoped>

@import "../globalComponents/style/_globals";

.dashboard {
	color: #fff;
}

</style>
